define('modules/auth/reset/reset.controller',["client"],
function(Prospector) {
    Prospector.module("AuthApp.Reset", function(Reset, Prospector, Backbone, Marionette, $, _){
        Reset.Controller = {
            loadReset: function(actions){
                require(["modules/auth/reset/views/reset.password.view",],
                function(ResetPasswordView){
                    document.title = 'RelPro: Forgot My Password';
                        var tokenPassView = new ResetPasswordView();
                        try {
                            window.token.fetch({success: function(){
                                Prospector.mainRegion.show(tokenPassView);
                            }});
                        } catch (e) {
                            window.location.reload();
                        }
                });
            }
        }
    });
    return Prospector.AuthApp.Reset.Controller;
});

